import { LegalPage } from "./legal-page.tsx";

export function TermsPage() {
  return <LegalPage slug="terms" />;
}
